export default function getExperienceAdditionalDiscount(price: number, percentage: number): number {
  if (!Number.isFinite(percentage) || percentage <= 0 || percentage >= 100) return 0
  return Number((percentage / 100 * price).toFixed(2))
}
